<template>
  <div v-if="item">
    <h6>ЗАКАЗ #{{ item.id }}</h6>
    <h5 class="badge badge-info">На оплату: {{ price | spaceBetweenNumber }} UZS</h5>
    <br/>

    <p>
      <a target="_blank" :href="`https://shop.ucell.uz/pay/${item.hash}`">{{`https://ucell-store.uz/pay/${item.hash}`}}</a> 
    </p>


    <div v-if="item.check_contacts && item.check_contacts.length">
    <h6>Дополнительные номера телефонов:</h6>
    <p v-for="contact in item.check_contacts" :key="contact.id"><b>{{contact.key}}</b>: {{contact.value}}</p>
      </div>

    <br/>

    <fields-list :item="item" :fields="fields" />
     <div class="save-panel">

      <fg-input v-model="comment" placeholder="Ваш комментарий"/>
      <button class="btn btn-sm btn-success btn-icon mt-1" @click="updateItem">
        <span class="ti-save"></span>Сохранить
      </button>

   
    </div>

    <br />
    <br />
    <br />
    
    <h4>Выставить счет по СМС на сумму {{ price | spaceBetweenNumber }} UZS</h4>
    <button @click="sendSMS" class="btn btn-sm btn-info btn-icon mr-2">
      Отправить СМС
    </button>
    <br />
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import { cardUpdate, cardContent } from "../../../plugins/functions";

import FieldsList from "../FieldsList";

export default {
  data: () => ({
    cardLink: "orders/card",
    cardSetLink: "orders/update",
    smsNotify: "orders/notify",
    item: null,
    comment:'',
    price: 0,
    fields: [
      {
        label: "Оплачен",
        key: "is_paid",
        type: "checkbox",
      },
      {
        col: "col-md-6 col-12",
        label: "Статус заказа",
        key: "status",
        type: "select",
        selectKey: "title",
        modal: "status",
        prefix: "product",
      },

      // {
      //   col: "col-md-6 col-12",
      //   label: "Способ покупки",
      //   key: "type",
      //   type: "select",
      //   selectKey: "title",
      //   modal: "type",
      // },
      {
        col: "col-md-6 col-12",
        label: "Метод оплаты",
        key: "payment",
        type: "select",
        selectKey: "title",
        modal: "payment",
      },

      {
        key: "customer",
        label: "Заказчик",
        type: "object",
        subFields: [
          {
            col: "col-md-6 col-12",
            key: "name",
            label: "Имя заказчкиа",
            type: "field",
            textType: "text",
          },
          {
            col: "col-md-6 col-12",
            key: "phone",
            label: "Контактный номер заказчика",
                type: "mask",
         mask: "+998#########",
          },
        ],
      },
      {
        key: "card",
        label: "Данные карты",
        type: "object",
        subFields: [
          {
            col: "col-md-8 col-12",
            key: "number",
            label: "Номер карты",
            type: "field",
            textType: "text",
          },
          {
            col: "col-md-4 col-12",
            key: "date",
            label: "Дата",
            type: "field",
            textType: "text",
          },
          {
            col: "col-md-6 col-12",
            key: "owner",
            label: "Владелец карты",
                type: "field",

          },
          {
            col: "col-md-6 col-12",
            key: "phone",
            label: "Телефон (привязана карта)",
                type: "mask",
         mask: "+998#########",
          },
        ],
      },
      {
        key: "passport",
        label: "Паспорт",
        type: "object",
        subFields: [
          {
            col: "col-md-4 col-12",
            key: "main",
            label: "Главное фото",
            type: "img",
            download: "download_main",
          },
          {
            col: "col-md-4 col-12",
            key: "location",
            label: "Прописка",
            type: "img",
            download: "download_location",
          },
          {
            col: "col-md-4 col-12",
            key: "selfie",
            label: "Селфи",
            type: "img",
            download: "download_selfie",
          },
        ],
      },
      {
        label: "Способ получения товара",
        key: "receipt_type",
        type: "static_radio",
        items: [
          { id: 1, title: "Самовывоз" },
          { id: 2, title: "Доставка" },
        ],
      },
      {
        label: "Адрес самовывоза",
        key: "shop",
        type: "select",
        selectKey: "title",
        modal: "shop",
      },

      {
        label: "Выберите вид доставки",
        key: "delivery",
        type: "select",
        selectKey: "title",
        modal: "delivery",
      },
      {
        key: "address",
        label: "Адрес заказчика",
        type: "object",
        subFields: [
          {
            col: "col-12",
            key: "location_id",
            label: "Выберите регион / город",
            type: "location",
          },
          {
            col: "col-md-6 col-12",
            key: "street_name",
            label: "Название улицы",
            type: "field",
            textType: "text",
          },
          {
            col: "col-md-6 col-12",
            key: "house_number",
            label: "Номер дома",
            type: "field",
            textType: "text",
          },
          {
            col: "col-md-6 col-12",
            key: "apartment_number",
            label: "Номер квартиры (необязательно)",
            type: "field",
            textType: "text",
          },
        ],
      },
      {
        key: "comment",
        label: "Комментарий клиента",
        type: "textarea",
      },
    ],
  }),
  components: {
    FieldsList,
  },
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
    this.price = this.item.price;
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, {...this.item, comment_from_admin:this.comment});
      if (item) {
        this.comment = '';
      }
      this.price = item.price;
    },
    async sendSMS() {
      await this.cardUpdate(this.smsNotify, this.item, "post");
    },
  },
  watch: {
    "item.receipt_type"(val) {
      for (let i = 0; i < this.fields.length; i++) {
        if (
          this.fields[i].key === "address" ||
          this.fields[i].key === "delivery"
        ) {
          if (val == 1) {
            this.fields[i].ishide = true;
          } else if (val == 2) {
            this.fields[i].ishide = false;
          }
        }
        if (this.fields[i].key === "shop") {
          if (val == 1) {
            this.fields[i].ishide = false;
          } else if (val == 2) {
            this.fields[i].ishide = true;
          }
        }
      }
    },
  },
};
</script>
<style>
</style>
